// vim: set ts=2 sw=2 et tw=72 ft=javascript:
/**
 * Copyright (C) 2015 Minted Inc.
 *
 * All Rights Reserved
 *
 * CTAG:COMMUNITY:ACTIVITY_FEED
 */

var module; UMD(module, {
  'minted:m': ['M'],
  'minted:vendor/backbone-1.0.0.min': 'Backbone',
  'minted:vendor/jquery-1.9.1.min': '$',
  'minted:vendor/underscore-1.8.2.min': '_',
  'templito:community/util': []
})(this, function (m_module, Backbone, $, _) {

  "use strict";

  var M = m_module.M;
  M.Community.View = M.Community.View || {};
  M.Community.View.Util = M.Community.View.Util || {};

  /**
   * @class M.Community.View.Util.ActivityFeedTile
   *
   */
  M.Community.View.Util.ActivityFeedTile = Backbone.View.extend({
    className: 'activityFeedTile',

    template: M.Template.Community.Util.ActivityFeedTile,

    // default parameter values
    callToAction: '',

    initialize: function() {
      this.$el = $(this.el);
    },

    render: function() {
      var activityType = this.model.get('activityType');

      var activityTypeAttrDict =
        M.COMMUNITY.ACTIVITY_FEED.TYPE_DICT[activityType];

      var messagePreviewDisplay = this.model.get('messagePreview');
      var calloutLinkText = activityTypeAttrDict['calloutLinkText'];
      var thumbnailUrl = this.model.get('activityThumbnailUrl');
      var calloutUrl = this.model.get('calloutUrl');

      var hasMessage = messagePreviewDisplay != null;
      var hasCallout = calloutLinkText != null;
      var hasThumbnail = thumbnailUrl != null;

      if (hasMessage) {
        messagePreviewDisplay = messagePreviewDisplay.truncate(40);
      }

      // Pass all the relevant information to the template
      var templateVars = {
        'hasMessage': hasMessage,
        'hasCallout': hasCallout,
        'hasThumbnail': hasThumbnail,
        'messagePreviewDisplay': messagePreviewDisplay,
        'calloutLinkText': calloutLinkText,
        'activityDescription': activityTypeAttrDict['description']
      };

      _.extend(templateVars, this.model.toJSON());
      this.$el.html(this.template(templateVars));

      // Attach the class associated with the activity type onto the
      // tile element
      var activityClass = activityTypeAttrDict['activityClass'];
      this.$el.addClass(activityClass);

      // Attach the class associated with the activity type icon image
      // to the tile's icon img element
      var imgClass = activityTypeAttrDict['imgClass'];
      this.$el.find('.activityTypeIcon').addClass(imgClass);

      return this;
    }
  });

  return {
  };

});